const de = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Ich lerne mit <br />SuperChinese Chinesisch. Mach doch mit!',
	'零基础任性学': 'Ohne Vorkenntnisse nach belieben lernen',
	'听说读写全面提升': 'Verbessern Sie Ihr Chinesisch im Lesen, Schreiben, Hörverstehen und Sprechen',
	'趣味对话': 'Unterhaltsame Konversationen',
	'100+日常对话等你来': '100+ alltagsnahe Konversationen warten auf Sie',
	'智能AI': 'Intelligente KI',
	'个性化学习推荐，由浅入深系统学': 'Personalisierte und systematische Lernerfahrungen, damit Ihr Einsatz sich lohn',
	'趣味对话等你来': 'Unterhaltsame Konversationen warten auf Sie',
	'立即打开': 'Jetzt öffnen',
	'我在SuperChinese<br />已累计学习{day}天': 'Ich benutze SuperChinese<br />und lerne bereits seit <span>{day}</span> Tagen',
	'我在SuperChinese<br />已连续学习{day}天': 'Ich benutze SuperChinese<br />ununterbrochen seit <span>{day}</span> Tagen',
	'学习生词': 'Gelernte<br />Vokabeln',
	'学习语法': 'Gelernte<br />Grammatik',
	'口语练习': 'Sprachübungen',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>Mal',
	'点击右上角的按钮,选择在浏览器中打开': 'Klicken Sie auf die Schaltfläche in der oberen rechten Ecke und wählen Sie "im Browser öffnen".',
	'邀请码': 'Einladungscode',
	'用邀请码注册，参与抽大奖': 'Laden Sie neue Nutzer ein, sich zu registrieren und den Einladungscode einzugeben, um an der Verlosung teilzunehmen.',
}
export default de;